import { render, staticRenderFns } from "./SankeyDiagram.vue?vue&type=template&id=43bc385a&scoped=true&"
import script from "./SankeyDiagram.vue?vue&type=script&lang=js&"
export * from "./SankeyDiagram.vue?vue&type=script&lang=js&"
import style0 from "./Style/sankey.scss?vue&type=style&index=0&id=43bc385a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc385a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43bc385a')) {
      api.createRecord('43bc385a', component.options)
    } else {
      api.reload('43bc385a', component.options)
    }
    module.hot.accept("./SankeyDiagram.vue?vue&type=template&id=43bc385a&scoped=true&", function () {
      api.rerender('43bc385a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyDiagram/SankeyDiagram.vue"
export default component.exports